import ConfirmationModal from '../../../../../components/basicModalConfirmation';
import { useGetValidatePaymentDataQuery, useSendPaymentsMutation } from '../../../../../services/PaymentToolApi';
import React, { useState } from 'react';
import { useNotification } from '../../../../../context/NotificationContext';
import { Button } from "@mui/material";
import { Alert, Box, CircularProgress, Modal, Snackbar, Typography } from '@mui/material';
import { createErrorMessage } from '../../../../../utils/index';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DataGridPro } from '@mui/x-data-grid-pro';
import {formatDateRangeToString} from '../../../../../utils/dates';
import { useGetAccountsFastListQuery } from '../../../../../services/accountsApi';


const styleModal = ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '950px',
    height: '65vh',
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: '1.5em',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
});

//period example object:
// "period": {
//     "id": 59,
//     "year": 2024,
//     "startDate": "2024-02-12T00:00:00",
//     "endDate": "2024-02-18T23:59:59.997",
//     "isCompleted": true,
//     "synchronizedWithPayPal": false
// }
function PaymentDataHeader({ paymentData }) {
    let period = paymentData?.period;
    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                <InfoOutlinedIcon align="center" color='primary' sx={{ margin: '0 0.25em 0 0' }} />
                <Typography id="modal-modal-description" variant='h6' align="center">  Are you sure you want to send this payment batch to PayPal?</Typography>
            </div>
            <Typography id="modal-modal-title" align="center">Send Payments for {formatDateRangeToString(paymentData?.period.startDate, paymentData?.period.endDate)}</Typography>
        </div>

    )
}

function PaymentDataTable({ paymentData }) {

    let items = paymentData?.payPalPayoutRequest?.items;
    // {
    //     "receiver": "userEmail@email.com",
    //     "amount": {
    //         "currency": "USD",
    //         "value": "116"
    //     },
    //     "recipient_type": "EMAIL", (always EMAIL)
    //     "note": null,
    //     "sender_item_id": "59-512", (periodID-userID)
    //     "recipient_wallet": null
    // }

    let columns = [
        {
            field: 'fullName',
            headerName: 'USERNAME',
            flex: 1,
        },
        {
            field: 'receiver',
            headerName: 'PAYMENT EMAIL',
            flex: 1,
        },
        {
            field: 'amount',
            headerName: 'AMOUNT',
            valueGetter: (params) => ("$" + params.row.amount.value + " " + params.row.amount.currency),
            flex: 0.35,
        },
        {
            field: 'sender_item_id',
            headerName: 'SENDER ITEM ID (periodID-userID)',
            flex: 0.25,
        }
    ]

    return (
        <DataGridPro
            sx={{ width: '100%' }}
            rows={items || []}
            columns={columns}
            rowHeight={38}
            checkboxSelection
            getRowId={(row) => row.sender_item_id}
        />
    )
}

function PaymentDataScreen({ paymentData }) {
    return (
        <>
            <PaymentDataHeader paymentData={paymentData} />
            <PaymentDataTable paymentData={paymentData} />
        </>
    )

}

export default function SendPaymentsModal({ open, setOpen, periodID }) {

    const { showNotification } = useNotification();

    const [sendPayments, { data, error, isLoading }] = useSendPaymentsMutation();
    const { data: paymentData, isLoading: paymentDataIsLoading, error: paymentDataError, isFetching: paymentDataIsFetching } = useGetValidatePaymentDataQuery({ periodID: periodID }, { skip: !periodID });
    const {data: users, isLoading: usersIsLoading, error: usersError} = useGetAccountsFastListQuery();

    function handleSubmit() {
        sendPayments({ PeriodID: periodID }).unwrap()
            .then((res) => {
                showNotification('Payments sent successfully', 'success');
                setOpen(false);
            })
            .catch((error) => {
                console.log(error)
                showNotification(createErrorMessage(error), 'error');
            });
    }

    let children;

    if(paymentDataIsLoading || paymentDataIsFetching || usersIsLoading){
        children = <CircularProgress />
    }
    else if (paymentDataError) {
        children = <Alert severity="error">Error loading payment data:  {createErrorMessage(paymentDataError)}</Alert>
    } else {

        let paymentDataAux= JSON.parse(JSON.stringify(paymentData || {}));
        paymentDataAux?.payPalPayoutRequest?.items.forEach((item) => {
            //in sender_item_id = periodID-userID
            let userID = item.sender_item_id.split("-")[1];
            console.log(userID)
            let user = users.find((user) => user.id == userID);
            item.fullName = user.fullName;
        });
        children = <PaymentDataScreen paymentData={paymentDataAux} />
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleModal}>
                    {children}
                    <Button variant="contained"
                        sx={{  width: '150px' }}
                        onClick={handleSubmit}
                        disabled={paymentDataIsLoading || paymentDataError || isLoading}
                    >
                        Send Payments
                    </Button>
                </Box>
            </Modal>

        </div>
    )
}
